import { render, staticRenderFns } from "./VersionsDialog.vue?vue&type=template&id=302b0bdd&scoped=true"
import script from "./VersionsDialog.vue?vue&type=script&lang=js"
export * from "./VersionsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302b0bdd",
  null
  
)

export default component.exports